import React from 'react';

function FacebookMessenger(props) {
  return (
    <svg height={24} width={24} xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        clipRule="evenodd"
        d="M2 11.2593C2 6.14549 6.47714 2 12 2C17.5229 2 22 6.14549 22 11.2593C22 16.373 17.5229 20.5185 12 20.5185C11.003 20.5185 10.0403 20.3828 9.13161 20.1313L5.72671 22V18.4696C3.45416 16.7723 2 14.1731 2 11.2593ZM10.4472 11.7531L12.9938 14.4691L18.4596 8.66667L13.5528 11.3827L10.9441 8.66667L5.47826 14.4691L10.4472 11.7531Z"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default FacebookMessenger;
